import { connect } from 'react-redux';
import InstallerTestScenariosModalComponent
  from './../Components/InstallerTestScenariosModalComponent.jsx';
import { modal as modalActions } from './../actions';
import {
  getModalVisibility,
  getScenariosByDispatcherId,
  getModalInfoByOwner
} from './../reducers';
import { owners } from './../helpers/modals';
import { dispatcher as dispatcherSelectors } from '../selectors';

export const mapStateToProps = (state) => {
  const dispatcherInfo = dispatcherSelectors.getDispatcherJobInfo(state);
  const scenarios = dispatcherInfo.dispatcherId ?
    getScenariosByDispatcherId(state, dispatcherInfo.dispatcherId) : [];
  let runners =
    getModalInfoByOwner(state, owners.installerTestsScenarios).runners || [];
  runners = runners.map(Number);

  return {
    visible: getModalVisibility(state, owners.installerTestsScenarios),
    runners: runners,
    scenarios: scenarios
  };
};

export default connect(
  mapStateToProps,
  {
    onHide: () => modalActions.showTestsScenariosModal(false, []),
    goToScenario: (scenarioNum) => modalActions.goToScenario(scenarioNum)
  }
)(InstallerTestScenariosModalComponent);


// WEBPACK FOOTER //
// src/Containers/InstallerTestScenariosModalContainer.jsx